<script setup>
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const allLabels = useMapGetter('labels/getLabels');

const toggle = title => {
  const next = props.modelValue.includes(title)
    ? props.modelValue.filter(t => t !== title)
    : [...props.modelValue, title];
  emit('update:modelValue', next);
};
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span v-if="label" class="text-sm font-medium text-n-slate-12">
      {{ label }}
    </span>
    <div
      class="flex flex-wrap gap-1.5 p-2 border border-n-weak rounded-xl min-h-[2.5rem] bg-n-background"
    >
      <button
        v-for="lbl in allLabels"
        :key="lbl.id"
        type="button"
        class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border transition-colors"
        :class="
          modelValue.includes(lbl.title)
            ? 'border-n-brand bg-n-blue-3 text-n-blue-11'
            : 'border-n-weak bg-n-slate-1 text-n-slate-11 hover:bg-n-slate-3'
        "
        @click="toggle(lbl.title)"
      >
        <span
          class="size-1.5 rounded-sm shrink-0"
          :style="{ background: lbl.color }"
        />
        {{ lbl.title }}
        <span
          v-if="modelValue.includes(lbl.title)"
          class="i-lucide-x size-3 opacity-60"
        />
      </button>
      <span v-if="!allLabels.length" class="text-xs text-n-slate-9 self-center">
        —
      </span>
    </div>
  </div>
</template>
